import { render, staticRenderFns } from "./yuDetails.vue?vue&type=template&id=939d9370&"
import script from "./yuDetails.vue?vue&type=script&lang=js&"
export * from "./yuDetails.vue?vue&type=script&lang=js&"
import style0 from "./yuDetails.vue?vue&type=style&index=0&id=939d9370&prod&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports